/**
 * Single source of truth for the VAT rate used across the PWA's
 * line-item / amount calculators. Any page that needs to compute
 * ex-VAT / inc-VAT splits (NewSale, EditSale, NewQuote, EditQuote,
 * CaptureExpense) imports this constant — if ZIMRA ever revises the
 * headline rate, this is the only place to update.
 *
 * Backend stores per-record `vat_rate` on each sale / quote so
 * historical records retain whatever rate applied at the time. This
 * constant is purely the mobile-form default.
 */
export const VAT_RATE = 0.155;
